module.exports = __webpack_public_path__ + "static/media/medalla-letra-M_2.1cb39e57.png";